import { render } from "./Verified.vue?vue&type=template&id=43b03318"
import script from "./Verified.vue?vue&type=script&lang=js"
export * from "./Verified.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/dgvt/dgvt-fuchs.de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__